// extracted by mini-css-extract-plugin
module.exports = {"tooltip--left":"tooltip__tooltip--left___GJz0c","tooltip--right":"tooltip__tooltip--right___gmg2q","tooltip--triangle":"tooltip__tooltip--triangle___HkKo1"};